// Secure access to employee KYC / HR documents.
//
// These files (PAN, Aadhaar, offer/appointment letters, salary slips, etc.)
// are NO LONGER public static files — the /uploads/team/* path is blocked in
// backend/server.js (except profile photos). They stream only through the
// authenticated endpoint GET /api/team/:id/document/:field, which is
// authorised as Admin/HR (any employee) or a member (their own record only).
import api from "../api/axios";

// field → human label, in a sensible display order. Field names match the
// team_members columns whitelisted in teamController.streamMemberDocument.
export const MEMBER_DOCUMENTS = [
  { field: "resume", label: "Resume / CV" },
  { field: "offer_letter", label: "Offer Letter" },
  { field: "appointment_letter", label: "Appointment Letter" },
  { field: "confirmation_letter", label: "Confirmation Letter" },
  { field: "employment_contract", label: "Employment Contract" },
  { field: "nda_agreement", label: "NDA Agreement" },
  { field: "pan_card", label: "PAN Card" },
  { field: "aadhar_card", label: "Aadhaar Card" },
  { field: "certificate", label: "Certificate" },
  { field: "edu_certificates", label: "Education Certificates" },
  { field: "other_edu_certificates", label: "Other Education Certificates" },
  { field: "salary_slip", label: "Previous Salary Slip" },
  { field: "reli_experience", label: "Relieving / Experience Letter" },
  { field: "exit_document", label: "Exit Document" },
];

// Open a protected document in a new tab. The tab is opened synchronously
// inside the click gesture (so pop-up blockers allow it), then pointed at the
// blob once it streams in. Throws on failure (403/404/etc.) — the caller
// shows the toast.
export async function openMemberDocument(memberId, field, params) {
  const win = window.open("", "_blank", "noopener,noreferrer");
  try {
    const res = await api.get(`/team/${memberId}/document/${field}`, {
      responseType: "blob",
      // Skill certificates are not a column of their own — they are addressed
      // as `skill_certificate` plus the skill's index (see utils/skills.js).
      ...(params ? { params } : {}),
    });
    const blob = new Blob([res.data], {
      type: res.data?.type || "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    if (win) {
      win.location = url;
    } else {
      // Pop-up blocked — fall back to a same-tab download.
      const a = document.createElement("a");
      a.href = url;
      a.download = `${field}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (win) win.close();
    throw err;
  }
}
